import { ReactNode } from "react";

export const Table = ({ children }: { children: ReactNode }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-bordered align-middle">
        <thead>
          <tr>
            <th scope="col" >Nombre</th>
            <th scope="col">Descripción</th>
            <th scope="col"  >Categoria</th>
            <th scope="col" >Fecha</th>
            <th scope="col" >Hora</th>
            <th scope="col" >Completada</th>
            <th scope="col">Aviso</th>
            <th scope="col" >Acciones</th>
          </tr>
        </thead>
        <tbody>{children}</tbody>
      </table>
    </div>
  );
};
